import { render, staticRenderFns } from "./FavouriteItems.vue?vue&type=template&id=21caa71a&scoped=true&"
import script from "./FavouriteItems.vue?vue&type=script&lang=js&"
export * from "./FavouriteItems.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteItems.vue?vue&type=style&index=0&id=21caa71a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21caa71a",
  null
  
)

export default component.exports